import React, { useContext, useState } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useFileDate() {
    const { apiPrefix } = useContext(ProductContext)
    const [fileDates, setFileDates] = useState([]);
    const [selectedFileDate, setSelectedFileDate] = useState('');

    const getFileDates = () => {
        request(true).get(endpoints[`${apiPrefix}_DATES`]).then(r => {
            setFileDates(r.data.dates)
        })
    }

    return { getFileDates, fileDates, selectedFileDate, setSelectedFileDate }
}